import { render, staticRenderFns } from "./SelectionMenuTabs.vue.html?vue&type=template&id=197fdca5&scoped=true&"
import script from "./SelectionMenuTabs.component.js?vue&type=script&lang=vueJs&"
export * from "./SelectionMenuTabs.component.js?vue&type=script&lang=vueJs&"
import style0 from "./SelectionMenuTabs.scoped.scss?vue&type=style&index=0&id=197fdca5&prod&lang=vueScss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197fdca5",
  null
  
)

export default component.exports